import { getPath } from '@/router/common'

const baseUrl = {
  title: '现金日记账',
  path: 'CCCashDayAccount'
}

export default [
  {
    path: getPath('CCAccountAdd', baseUrl),
    name: 'CCAccountAdd',
    component: () => import(/* webpackChunkName: "CCAccountAdd" */ '@/views/cCCashDayAccount/cCAccountAdd/index.vue'),
    meta: {
      title: '现金日记账'
    }
  },
]
